import React, { useRef } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderClosed } from "@fortawesome/free-solid-svg-icons";

import useConfigs from "../../hooks/useConfigs";
import useThemes from "../../hooks/useThemes";

const FileInputContainer = styled.div`
  margin-bottom: 1rem;

  input {
    display: none !important;
  }

  h4 {
    color: ${(props) => props.backgroundbtn};
    font-weight: 700;
    text-transform: uppercase;
  }

  label {
    width: 100%;
  }

  .button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-left: 2rem;
    border-radius: 2rem;
    border: 1px solid ${(props) => props.bordercolor};
    background-color: ${(props) => props.backgroundinput};
    overflow: hidden;

    span {
      width: 60%;
      word-wrap: break-word;
    }

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40%;
      padding: 1.2rem;
      background-color: ${(props) => props.backgroundbtn};
      border-radius: 2rem;
      color: ${(props) => props.btncolor};
    }
  }

  p {
    margin-top: 0.5rem;
    color: #ff7777;
  }
`;

const CustomFileInput = ({ label, width, error, value, onChange, onBlur }) => {
  const { fontSizeMultiplier } = useConfigs();
  const { colorPrincipal, colorSexto, backgroundDecimo, backgroundWhite } =
    useThemes();

  const inputRef = useRef();

  return (
    <FileInputContainer
      style={{ width: width }}
      backgroundbtn={colorPrincipal}
      backgroundinput={backgroundDecimo}
      bordercolor={colorSexto}
      btncolor={backgroundWhite}
    >
      <label htmlFor="file">
        <h4 style={{ fontSize: 15 * fontSizeMultiplier }}>{label}</h4>
        <div className="button">
          <span>
            {inputRef?.current?.files.length !== 0
              ? inputRef.current?.files[0]?.name
              : "Seleccionar soporte"}
          </span>

          <div>
            Examinar{" "}
            <FontAwesomeIcon
              icon={faFolderClosed}
              color="#fff"
              style={{ marginLeft: "1rem" }}
            />
          </div>
        </div>
      </label>

      <input
        ref={inputRef}
        id="file"
        style={{ fontSize: 15 * fontSizeMultiplier }}
        type="file"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />

      <p style={{ fontSize: 15 * fontSizeMultiplier }}>{error?.message}</p>
    </FileInputContainer>
  );
};

export default CustomFileInput;

CustomFileInput.propTypes = {
  label: PropTypes.string,
  width: PropTypes.string,
  error: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

CustomFileInput.defaultProps = {
  width: "100%",
};
